module.exports = __webpack_public_path__ + "img/onile_banner.4d867377.png";